import {Col, Container, Row} from "react-bootstrap";
import logo from '../assets/img/logo.png';
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg"
import {ContactInfo} from "./ContactInfo";

export const Footer = () => {
    return (
        <footer className="footer">
            <Container>
                <Row className="align-items-center">
                    <ContactInfo/>
                    <Col size={12} sm={6}>
                        <a href="#">
                            <img src={logo} alt="Logo"/>
                        </a>
                    </Col>
                    <Col size={12} sm={6} className="footer-text text-center text-sm-end">
                        <div className="social-icon">
                            <a href="https://www.linkedin.com/in/jennifercoenraad" target="_blank"
                               rel="noopener noreferrer"><img src={navIcon1}
                                                              alt="Icon"/></a>
                            <a href="https://www.instagram.com/xanimegamerjcx" target="_blank"
                               rel="noopener noreferrer"><img src={navIcon2}
                                                              alt="Icon"/></a>
                            <a href="https://github.com/JCoenraad" target="_blank"
                               rel="noopener noreferrer"><img src={navIcon3}
                                                              alt="Icon"/></a>
                        </div>
                        <p>© 2025 - {new Date().getFullYear()} <a href="https://jcoenraad.com">JCoenraad.com</a>. All
                           Rights Reserved.
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}
